import { useQuery } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";

const getBrandsQueryKey = () => configurationApi.queryOptions("get", "/api/Brand").queryKey;

export const useBrands = () => {
  const { showToast } = useToast();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: getBrandsQueryKey(),
    queryFn: async () => {
      const response = await configurationApi.client.GET("/api/Brand");
      if (response.error) {
        const errorMessage = `Failed to fetch brands: ${response.error.toString()}`;
        showToast("error", "Error", errorMessage);
        throw new Error(errorMessage);
      }
      return response.data || [];
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    brands: data || [],
    isLoading,
    error,
    refetch,
  };
};

export const useBrand = (brandId: number | undefined) => {
  const { brands, isLoading, error } = useBrands();

  const brand = brandId ? brands.find((b) => b.id === brandId) : undefined;

  return {
    brand,
    isLoading,
    error,
  };
};
